
const getUniqueObjects = (array) => {
	const keys = Object.keys(array[0])
	return [... new Set(array.map(item => Object.values(item).toString()))].map(
		list => {
			let tempList = list.split(",")
			let tempObject = {}
			for (let i in tempList) {
				tempObject[keys[i]] = tempList[i]
			}
			return tempObject
		}
	)
}

export { getUniqueObjects }